import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import ContactSection from './templates/molecules/contact-section';

loadWidget('.plf-contact-area', contactWidget => {
    const action = contactWidget.dataset.action;
    ReactDOM.render(<ContactSection action={action} />, contactWidget);
});
